import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinkothrud() {

const cardData = {
keyword: "Urbania on Rent in Kothrud",
headingDescription: "Urbania on Rent in Kothrud is a convenient group transportation solution for family trips, corporate events, weddings, airport transfers, sightseeing, pilgrimage journeys, and outstation travel. Ruturaj Enterprises provides spacious Urbania vehicles with comfortable seating, air conditioning options, professional driver assistance, and flexible arrangements for different group requirements. Customers from Kothrud, Karve Nagar, Bavdhan, Paud Road, Chandni Chowk, and nearby western Pune areas can arrange Urbania transportation for local as well as longer journeys.",
topPlaces: [
{
title: "Kothrud",
description: "Kothrud is one of the major residential and commercial areas of western Pune, with convenient connectivity to educational institutions, offices, shopping areas, and major highways. Urbania hire from Kothrud can support family trips, corporate events, weddings, airport transfers, sightseeing, and outstation journeys."
},
{
title: "Karve Nagar",
description: "Karve Nagar is a well-connected residential and educational locality close to Kothrud. A spacious Urbania can be arranged from Karve Nagar for family functions, student groups, corporate travel, wedding transportation, airport transfers, pilgrimage trips, and outstation tours."
},
{
title: "Bavdhan",
description: "Bavdhan is located along the western Pune corridor and provides access toward Kothrud, Paud Road, and the Mumbai-Pune route. Urbania transportation from Bavdhan is suitable for family holidays, corporate programs, weddings, group tours, airport travel, and intercity journeys."
},
{
title: "Paud Road",
description: "Paud Road connects Kothrud with Bavdhan, Pirangut, Mulshi, and several western Pune destinations. An Urbania can be arranged from this corridor for group travel, family trips, corporate outings, weddings, pilgrimage journeys, and outstation travel."
},
{
title: "Chandni Chowk",
description: "Chandni Chowk is an important western Pune junction connecting Kothrud and Bavdhan with the Mumbai-Pune Expressway and nearby destinations. Urbania services can support group transfers, corporate travel, family holidays, airport transportation, and outstation journeys from this location."
},
{
title: "Deccan Gymkhana",
description: "Deccan Gymkhana is a central Pune destination with educational institutions, commercial establishments, hotels, and cultural venues. Groups can use Urbania transportation between Kothrud and Deccan for corporate events, family functions, weddings, sightseeing, and organized travel."
},
{
title: "Shivajinagar",
description: "Shivajinagar is a major central Pune transportation and business hub with access to railway and bus connections. A 13-seater or larger Urbania can be useful for group transfers, corporate programs, family travel, wedding guests, airport journeys, and outstation trips."
},
{
title: "Pune International Airport",
description: "Pune International Airport is an important destination for families, business travellers, and groups travelling from Kothrud and western Pune. An Urbania provides a convenient option when several passengers and their luggage need to travel together for an airport pickup or drop."
},
{
title: "Aundh",
description: "Aundh is a major residential and commercial locality in western Pune with offices, hospitals, hotels, and business establishments. Urbania transportation can be arranged for corporate groups, family functions, wedding travel, airport transfers, and journeys connecting Aundh with Kothrud."
},
{
title: "Warje",
description: "Warje provides convenient access between Kothrud, Bavdhan, Sinhagad Road, and western Pune. A spacious Urbania from the Kothrud region can be used for family trips, corporate events, pilgrimage tours, weddings, sightseeing, and outstation group travel."
}
],
services: [
{
name: "Urbania on Rent Kothrud",
description: "Urbania on Rent Kothrud provides spacious group transportation for families, corporate teams, tourists, wedding groups, and event participants. It can be arranged for local Pune travel, airport transfers, sightseeing, family functions, corporate programs, and outstation journeys."
},
{
name: "Urbania on Rent Karve Nagar",
description: "Urbania on Rent Karve Nagar is suitable for groups starting from Karve Nagar and nearby areas. The vehicle can be used for family holidays, weddings, corporate travel, school or college trips, airport transfers, pilgrimage journeys, and outstation tours."
},
{
name: "Urbania on Rent Bavdhan",
description: "Urbania on Rent Bavdhan provides a convenient group vehicle for customers travelling from Bavdhan and the western Pune corridor. It is suitable for corporate events, family trips, weddings, sightseeing, airport transfers, and longer intercity journeys."
},
{
name: "Urbania Traveller Paud Road",
description: "Urbania Traveller Paud Road is useful for groups travelling along the Paud Road corridor toward Mulshi, Pirangut, Kothrud, and other western destinations. It can support family travel, corporate outings, weddings, pilgrimage trips, sightseeing, and outstation journeys."
},
{
name: "13 Seater Urbania on Rent in Kothrud",
description: "13 Seater Urbania on Rent in Kothrud is suitable for medium-sized groups requiring comfortable shared transportation. It can be arranged for family trips, corporate events, wedding functions, airport transfers, sightseeing, and outstation travel."
},
{
name: "17 Seater Urbania on Rent in Kothrud",
description: "17 Seater Urbania on Rent in Kothrud is a practical option for larger groups travelling together. It can support corporate teams, families, event participants, wedding guests, school groups, pilgrimage tours, and longer outstation journeys."
},
{
name: "Urbania Hire in Kothrud Pune",
description: "Urbania Hire in Kothrud Pune provides group transportation for customers who need a spacious vehicle with professional driver assistance. It is suitable for local travel, corporate programs, family functions, weddings, airport transfers, sightseeing, and intercity journeys."
},
{
name: "Urbania Booking in Kothrud",
description: "Urbania Booking in Kothrud allows customers to plan their group transportation according to the required date, pickup point, destination, passenger capacity, and travel itinerary. Advance arrangements are useful for weddings, events, holidays, airport transfers, and outstation tours."
},
{
name: "AC Urbania on Rent in Kothrud",
description: "AC Urbania on Rent in Kothrud provides an air-conditioned group transportation option for passengers seeking a comfortable travel environment. It can be arranged for family trips, corporate events, weddings, airport transfers, sightseeing, and longer journeys."
},
{
name: "Non AC Urbania on Rent in Kothrud",
description: "Non AC Urbania on Rent in Kothrud provides an alternative group travel option for customers who do not require air conditioning. It can be useful for selected local events, group programs, family functions, educational trips, and suitable outstation travel."
},
{
name: "Luxury Urbania on Rent in Kothrud",
description: "Luxury Urbania on Rent in Kothrud offers a premium group transportation solution for special occasions and longer journeys. It is suitable for executive travel, corporate events, weddings, family celebrations, sightseeing, and organized outstation tours."
},
{
name: "Urbania Rental Service in Kothrud",
description: "Urbania Rental Service in Kothrud provides flexible transportation for families, companies, tourists, and event groups. Customers can arrange vehicles for local travel, corporate functions, weddings, airport transfers, sightseeing, pilgrimage tours, and outstation journeys."
},
{
name: "Urbania for Outstation in Kothrud",
description: "Urbania for Outstation in Kothrud is suitable for groups travelling from western Pune to tourist destinations, pilgrimage locations, nearby cities, and other intercity routes. The spacious vehicle allows passengers to travel together with professional driver assistance."
},
{
name: "Urbania for Corporate Events in Kothrud",
description: "Urbania for Corporate Events in Kothrud can be arranged for conferences, seminars, team outings, annual functions, meetings, exhibitions, and company celebrations. It provides convenient transportation for employees, clients, and guests between offices, hotels, and event venues."
},
{
name: "Urbania for Wedding Function in Kothrud",
description: "Urbania for Wedding Function in Kothrud is useful for transporting relatives, guests, family members, and event participants between homes, hotels, wedding venues, and reception locations. A dedicated vehicle helps simplify group movement during the wedding schedule."
},
{
name: "Urbania for Airport Pickup Kothrud",
description: "Urbania for Airport Pickup Kothrud provides group transportation to collect multiple passengers from Pune International Airport. The spacious vehicle can accommodate passengers and luggage while keeping families, corporate teams, and event groups together."
},
{
name: "Best Urbania Rental in Kothrud",
description: "Best Urbania Rental in Kothrud is a search term for customers looking for a suitable group vehicle with spacious seating, professional driver assistance, and flexible travel arrangements. It can support corporate, family, wedding, airport, sightseeing, and outstation requirements."
},
{
name: "Urbania Tempo Traveller in Kothrud",
description: "Urbania Tempo Traveller in Kothrud is suitable for families, corporate teams, tourists, and event participants requiring spacious group transportation. It can be arranged for sightseeing, airport transfers, weddings, business travel, pilgrimage tours, and longer journeys."
},
{
name: "Urbania on Rent Near Paud Road",
description: "Urbania on Rent Near Paud Road is convenient for groups travelling around Kothrud, Bavdhan, Pirangut, and western Pune. It can be used for family holidays, corporate outings, weddings, sightseeing, pilgrimage tours, airport transfers, and outstation travel."
},
{
name: "Urbania on Rent Near Karve Nagar",
description: "Urbania on Rent Near Karve Nagar provides a practical group vehicle for families, students, companies, and event participants. It can be arranged for weddings, corporate programs, airport transfers, family trips, sightseeing, and intercity journeys."
},
{
name: "Urbania on Rent Near Chandni Chowk",
description: "Urbania on Rent Near Chandni Chowk is useful for groups travelling through the western Pune corridor and connecting toward the Mumbai-Pune Expressway. It can support family travel, corporate events, airport transportation, weddings, and outstation tours."
},
{
name: "Urbania for Family Trip in Kothrud",
description: "Urbania for Family Trip in Kothrud provides a convenient group vehicle for families travelling together for holidays, weddings, religious visits, sightseeing, and special functions. One spacious vehicle makes coordination easier and keeps the group together."
},
{
name: "Urbania for Group Travel Kothrud",
description: "Urbania for Group Travel Kothrud is suitable for friends, families, corporate teams, tourists, wedding groups, and organized tour parties. It can be used for local Pune transportation as well as longer outstation journeys with a planned itinerary."
}
],
tableData: [
["Urbania on Rent Kothrud"],
["Urbania on Rent Karve Nagar"],
["Urbania on Rent Bavdhan"],
["Urbania Traveller Paud Road"],
["13 Seater Urbania on Rent in Kothrud"],
["17 Seater Urbania on Rent in Kothrud"],
["Urbania Hire in Kothrud Pune"],
["Urbania Booking in Kothrud"],
["AC Urbania on Rent in Kothrud"],
["Non AC Urbania on Rent in Kothrud"],
["Luxury Urbania on Rent in Kothrud"],
["Urbania Rental Service in Kothrud"],
["Urbania for Outstation in Kothrud"],
["Urbania for Corporate Events in Kothrud"],
["Urbania for Wedding Function in Kothrud"],
["Urbania for Airport Pickup Kothrud"],
["Best Urbania Rental in Kothrud"],
["Urbania Tempo Traveller in Kothrud"],
["Urbania on Rent Near Paud Road"],
["Urbania on Rent Near Karve Nagar"],
["Urbania on Rent Near Chandni Chowk"],
["Urbania for Family Trip in Kothrud"],
["Urbania for Group Travel Kothrud"]
],
whychoose: [
{
WhyChooseheading: "Spacious Group Travel from Kothrud",
WhyChoosedescription: "Urbania vehicles provide a convenient transportation solution for families, corporate teams, tourists, wedding groups, and event participants travelling from Kothrud. The larger seating capacity helps groups travel together instead of arranging several separate cars."
},
{
WhyChooseheading: "Multiple Seating Options",
WhyChoosedescription: "Ruturaj Enterprises can cater to different group sizes with suitable Urbania options, including 13-seater and 17-seater requirements. This flexibility allows customers to select a vehicle based on passenger count and the nature of their journey."
},
{
WhyChooseheading: "Comfortable for Long-Distance Travel",
WhyChoosedescription: "Western Pune has direct access to several popular outstation routes, making comfortable group transportation important for longer journeys. Urbania vehicles are suitable for family holidays, corporate trips, pilgrimage tours, weddings, and multi-day group travel."
},
{
WhyChooseheading: "Useful for Corporate Events",
WhyChoosedescription: "Companies can arrange Urbania transportation for conferences, seminars, employee outings, meetings, annual functions, and business events. A dedicated group vehicle helps coordinate employees and guests between offices, hotels, airports, and event venues."
},
{
WhyChooseheading: "Convenient Wedding Transportation",
WhyChoosedescription: "Wedding groups can use Urbania vehicles to move relatives and guests between homes, hotels, wedding venues, and reception locations. Keeping multiple passengers together makes guest transportation easier to coordinate during busy event schedules."
},
{
WhyChooseheading: "Airport Transfer Support",
WhyChoosedescription: "Customers travelling from Kothrud and nearby western Pune areas can use Urbania for coordinated transfers to and from Pune International Airport. The spacious vehicle is particularly useful when several passengers are travelling together with luggage."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "A dedicated professional driver can make group transportation more convenient, especially for unfamiliar destinations and multi-stop itineraries. Passengers can focus on their family plans, business activities, or event schedules during the journey."
},
{
WhyChooseheading: "Convenient Western Pune Pickup Coverage",
WhyChoosedescription: "Ruturaj Enterprises can arrange Urbania transportation around Kothrud and nearby areas such as Karve Nagar, Bavdhan, Paud Road, Chandni Chowk, Deccan Gymkhana, Shivajinagar, Aundh, and Warje according to the customer's travel requirement."
}
]
};

















const faqData = [
{
question: "How can I hire an Urbania on rent in Kothrud?",
answer: "Customers can enquire about Urbania rental in Kothrud by sharing the pickup location, travel date, destination, passenger count, trip duration, and planned itinerary. Ruturaj Enterprises can discuss suitable group transportation for family tours, corporate travel, weddings, sightseeing programs, religious trips, airport transfers, and outstation journeys."
},
{
question: "Who can rent an Urbania in Kothrud?",
answer: "Families, corporate teams, wedding groups, schools, colleges, tour operators, and other organizations can enquire about an Urbania in Kothrud. It can be useful when a larger group wants to travel together instead of arranging several smaller cars for the same journey."
},
{
question: "Can I hire an Urbania from Kothrud for an outstation trip?",
answer: "An Urbania can be arranged for group journeys from Kothrud to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Goa, Aurangabad, and other cities or tourist destinations. One-way, round-trip, and multi-day requirements can be discussed according to the route."
},
{
question: "Is an Urbania suitable for family tours starting from Kothrud?",
answer: "Families can consider an Urbania for vacations, reunions, religious tours, sightseeing programs, and extended group journeys from Kothrud. Travelling together can make it easier to coordinate departure times, hotel transfers, sightseeing stops, and return travel throughout the itinerary."
},
{
question: "Can I book an Urbania in Kothrud for weddings and family functions?",
answer: "Wedding organizers can enquire about an Urbania for transporting relatives and guests between homes, hotels, marriage venues, reception halls, railway stations, and airports. The vehicle can be scheduled around the function timings when multiple guests need transportation between different locations."
},
{
question: "Can companies hire an Urbania on rent in Kothrud for corporate travel?",
answer: "Businesses can arrange an Urbania for employee outings, conferences, training programs, team-building activities, corporate events, and client transportation. Pickup points, office locations, reporting times, passenger count, and event destinations can be shared with Ruturaj Enterprises while planning the journey."
},
{
question: "Can Urbania be rented from Kothrud for Pune Airport transfers?",
answer: "An Urbania can be useful for group airport transportation between Kothrud and Pune Airport. Customers can provide flight details, passenger count, luggage requirements, pickup address, and required reporting time so the airport transfer can be planned around the group's schedule."
},
{
question: "Can I hire an Urbania from Kothrud for Pune sightseeing?",
answer: "Tour groups and families can enquire about Urbania rental for sightseeing trips starting from Kothrud. The itinerary can include multiple attractions, meal stops, hotel pickups, and return travel, allowing the entire group to remain together during the sightseeing program."
},
{
question: "Can schools and colleges rent an Urbania in Kothrud?",
answer: "Educational institutions and student groups can enquire about an Urbania for picnics, excursions, educational visits, industrial tours, and recreational programs. Passenger count, pickup point, destination, travel date, schedule, and trip duration can be provided when discussing the transportation requirement."
},
{
question: "What details are required to book an Urbania on rent in Kothrud?",
answer: "Customers can provide the Kothrud pickup address, destination, travel date, number of passengers, rental duration, route details, and expected return time. Information about multiple stops, airport transfers, hotel pickups, wedding functions, corporate programs, sightseeing, or other travel requirements can also be shared with Ruturaj Enterprises."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Yogesh Deshpande",
feedback:
"We were planning a group holiday from Kothrud to Mahabaleshwar and needed one vehicle for the entire family. Ruturaj Enterprises arranged an Urbania according to our pickup schedule. Everyone could travel together, and managing the different stops during the trip was much simpler than arranging separate cars.",
rating: 5
},
{
id: 2,
name: "Miss. Pallavi Joshi",
feedback:
"Our company arranged a team event outside Pune and needed transportation from Kothrud for a group of employees. We shared the event timings and route with Ruturaj Enterprises, and the Urbania arrangement made the group movement convenient. It was particularly helpful for keeping everyone together during the return journey.",
rating: 5
}
];



































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Kothrud",
  "image": "https://ruturajenterprises.com/assets/images/urbania-on-rent-in-kothrud.webp",
  "description": "Urbania on Rent in Kothrud from Ruturaj Enterprises is a spacious and convenient transportation option for families, corporate groups, wedding parties, tourists and passengers planning local or outstation journeys. Urbania on Rent Kothrud, Urbania on Rent Karve Nagar, Urbania on Rent Bavdhan and Urbania Traveller Paud Road provide convenient group travel options across western Pune. 13 Seater Urbania on Rent in Kothrud and 17 Seater Urbania on Rent in Kothrud are suitable for different group sizes, offering comfortable seating for family tours, corporate programs, events and longer journeys. Urbania Hire in Kothrud Pune and Urbania Booking in Kothrud can be arranged for planned trips, sightseeing and special occasions. AC Urbania on Rent in Kothrud and Luxury Urbania on Rent in Kothrud are suitable for passengers seeking a comfortable and premium travel experience, while Non AC Urbania on Rent in Kothrud provides another practical option. Urbania Rental Service in Kothrud can support outstation travel, corporate events, wedding functions and airport transfers. Urbania for Outstation in Kothrud is suitable for intercity journeys, while Urbania for Corporate Events in Kothrud and Urbania for Wedding Function in Kothrud can help transport teams, guests and families together. Urbania for Airport Pickup Kothrud is useful for passengers travelling to or from Pune Airport. Customers near important western Pune areas can also choose Urbania on Rent Near Paud Road, Urbania on Rent Near Karve Nagar and Urbania on Rent Near Chandni Chowk. Best Urbania Rental in Kothrud, Urbania Tempo Traveller in Kothrud, Urbania for Family Trip in Kothrud and Urbania for Group Travel Kothrud provide flexible options for holidays, pilgrimages, family functions, corporate travel and group tours.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/urbania-on-rent-in-kothrud"
  }
};







    return (
        <div>

<Helmet>
  <title>
    Urbania on Rent in Kothrud | 13 & 17 Seater Luxury Traveller for Group & Outstation Travel | +91 9763381382
  </title>

  <meta
    name="description"
    content="Urbania on Rent in Kothrud by Ruturaj Enterprises for 13 and 17 seater group travel, family trips, corporate events, weddings, airport pickup, Paud Road, Karve Nagar, Chandni Chowk and outstation journeys."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Kothrud, Urbania on Rent Kothrud, Urbania on Rent Karve Nagar, Urbania on Rent Bavdhan, Urbania Traveller Paud Road, 13 Seater Urbania on Rent in Kothrud, 17 Seater Urbania on Rent in Kothrud, Urbania Hire in Kothrud Pune, Urbania Booking in Kothrud, AC Urbania on Rent in Kothrud, Non AC Urbania on Rent in Kothrud, Luxury Urbania on Rent in Kothrud, Urbania Rental Service in Kothrud, Urbania for Outstation in Kothrud, Urbania for Corporate Events in Kothrud, Urbania for Wedding Function in Kothrud, Urbania for Airport Pickup Kothrud, Best Urbania Rental in Kothrud, Urbania Tempo Traveller in Kothrud, Urbania on Rent Near Paud Road, Urbania on Rent Near Karve Nagar, Urbania on Rent Near Chandni Chowk, Urbania for Family Trip in Kothrud, Urbania for Group Travel Kothrud, Urbania Traveller Kothrud, Urbania with Driver Kothrud, 13 Seater Urbania Kothrud, 17 Seater Urbania Kothrud, Urbania Corporate Cab Kothrud, Urbania Corporate Travel Kothrud, Urbania Airport Transfer Kothrud, Urbania Wedding Rental Kothrud, Urbania Family Tour Kothrud, Urbania Outstation Rental Kothrud, Urbania Group Transportation Kothrud, Urbania Rental Near Paud Road, Urbania Rental Near Karve Nagar, Urbania Rental Near Chandni Chowk, Urbania Bus Rental Kothrud, Urbania Traveller Hire Kothrud, Luxury Urbania Traveller Kothrud"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/108.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinkothrud;